//
import Service from '@/services/api/service'
import CostCenterModel from '@/models/Accounting/AccCostCenter'

//
//import filters from './filters'
//import headers from './headers'

//
export default class extends Service {

    //
    //static filters  = filters
    //static headers  = headers
    
    //
    static model = CostCenterModel
}
